import React from 'react'
import Navbar from './Navbar'
import Upload from './Upload'
export default function MainWebPage() {
  return (
    <>
      <Navbar />
    <div className="container-fluid1">
      <div class="example1">
        <h3>Welcome to i-notes!!! one stop solution for notes</h3>
        <br />
      </div>
      <div className='bck' >
        <div className='List'>
        <Upload />
        
          <div className='one'>
            <br />
            <p><mark >BCA CSC 2021 end term papers</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1YfHfDSRe95-2XTFYMpesYlf8mm0rvauZ/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >Operating System</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1es1wOj48jPX5n6KUHajjrjsdb5DXO3hH/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >Software Engineering</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1NGqWsA0uKOFD5vgJt3CfAYNNVdXcH0up/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >Internet Programming</mark></p>
            <a className="one" rel="ext"  href="https://drive.google.com/file/d/1FiB_SoJa_FhuB6kH5PxxpKW6Q7Ebx0DR/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >Formal Language and Automata Theory</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1IYqUuYnFwLUah_5-kt3Bw2jV86IzfztL/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >System Programming</mark></p>
            <a className="one" rel="ext"  href="https://drive.google.com/file/d/1p11mKxeIyDFxY9dtGZuOgeDxH21w6UpG/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >C++</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1L9MvI09tNma4sXIm_eV_hdmpBAE4YrU9/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >Computer Organization and Architecture</mark></p>
            <a className="one" rel="ext"  href="https://drive.google.com/file/d/14UocnpG2cVZ_nbJrlh_Sub4GFTBmePUK/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >Computer Graphics and HCI</mark></p>
            <a className="one" rel="ext"  href="https://drive.google.com/file/d/1b6q2vFL-ijIDIi18Vd-InopDH_jfjQrt/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >JAVA</mark></p>
            <a className="one" rel="ext"  href="https://drive.google.com/file/d/12b5ff7NYZemq32wdVcrrfwRDh1e13cnA/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >Artificial Intelligence</mark></p>
            <a className="one" rel="ext"  href="https://drive.google.com/file/d/1CwXuU7jeptkyLxlBxvR9ChBZHQX3s5OV/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >System and Network administration</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1BUxlrqh0BPLNbol5DIkVORkRvIWbXVBL/view?usp=sharing">download</a>
            <br />
            <br />
            <p><mark >DBMS</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1ajxzo0k4iyX2KPT6WQ0cWMf5T7gaNXcu/view">download</a>
            <br />
            <br />
            <p><mark >Computer Networks</mark></p>
            <a className="one" rel="ext" href="https://drive.google.com/file/d/1bgclIbQLwptlIZFjzM2mq0X9jgNWXJF2/view?usp=sharing">download</a>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
     
      
    </>
  )
}
